import type { MarketUrlParams } from '@/lend/types/lend.types'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { NETWORK_SWITCH_UNAVAILABLE } from '@ui/features/layout/switch-chain/switch-policies'
import { redirectTo } from '@ui/hooks/router'
import { t } from '@ui/lib/i18n'
import { rootRoute } from './root.routes'
import { createSharedRoutes } from './shared.routes'

const LendLayout = lazyRouteComponent(() => import('@/lend/LendLayout'), 'LendLayout')
const LendMarketPage = lazyRouteComponent(
  () => import('@/lend/components/PageLendMarket/LendMarketPage'),
  'LendMarketPage',
)
const PageVault = lazyRouteComponent(() => import('@/lend/components/PageVault/Page'), 'Page')

const lendLayoutRoute = createRoute({ getParentRoute: () => rootRoute, path: 'lend', component: LendLayout })

const layoutProps = { getParentRoute: () => lendLayoutRoute }

const toastTitle = (networkName?: string) =>
  networkName ? t`This market is only available on ${networkName}` : NETWORK_SWITCH_UNAVAILABLE

export const lendRoutes = lendLayoutRoute.addChildren([
  ...createSharedRoutes('lend', layoutProps),
  createRoute({
    path: '$network',
    loader: ({ params: { network } }) => redirectTo(`/lend/${network}/markets`),
    ...layoutProps,
  }),
  createRoute({
    path: '$network/markets',
    loader: ({ params: { network } }) => redirectTo(`/llamalend/${network}/markets`),
    ...layoutProps,
  }),
  createRoute({
    path: '$network/markets/$market',
    staticData: { networkSwitch: { type: 'locked', toastTitle } },
    component: LendMarketPage,
    head: ({ params: { market } }: { params: MarketUrlParams }) => ({
      meta: [{ title: `${market} - Curve Llamalend` }],
    }),
    ...layoutProps,
  }),
  createRoute({
    path: '$network/markets/$market/create/{-$formType}',
    loader: ({ params: { network, market } }: { params: MarketUrlParams }) =>
      redirectTo(`/lend/${network}/markets/${market}`),
    ...layoutProps,
  }),
  createRoute({
    path: '$network/markets/$market/manage/{-$formType}',
    loader: ({ params: { network, market } }: { params: MarketUrlParams }) =>
      redirectTo(`/lend/${network}/markets/${market}`),
    ...layoutProps,
  }),
  createRoute({
    path: '$network/markets/$market/vault/$formType',
    loader: ({ params: { network, market } }) => redirectTo(`/lend/${network}/markets/${market}/vault`),
    ...layoutProps,
  }),
  createRoute({
    path: '$network/markets/$market/vault',
    staticData: { networkSwitch: { type: 'locked', toastTitle } },
    component: PageVault,
    head: ({ params: { market } }: { params: MarketUrlParams }) => ({
      meta: [{ title: `Supply - ${market} - Curve Llamalend` }],
    }),
    ...layoutProps,
  }),
])
